import React, { Component } from 'react';
import { FormGroup, FormText, Input } from 'reactstrap';
import { Translate, withLocalize } from 'react-localize-redux';

import PropTypes from 'prop-types';


class Review extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      clicked: false,
    };
  }

  handleClick() {
    this.setState({
      clicked: true,
    });
  }

  render() {
    const {
      activeLanguage,
      chsite,
      handleChange,
      isSubmitted,
      review,
      validate,
    } = this.props;

    const { clicked } = this.state;

    const reviewPlaceholder = activeLanguage.code === 'gb'
      ? `How was your visit to ${chsite.name}?`
      : `Comment était votre visite ${chsite.name}?`;

    return (
      <FormGroup>
        <h4 className="title">
          <Translate id="review.title" />
          {' '}
          *
          {' '}
        </h4>

        <Input
          id="review"
          type="textarea"
          placeholder={reviewPlaceholder}
          valid={validate()}
          invalid={(!validate() && clicked) || (!validate() && isSubmitted)}
          value={review}
          onChange={handleChange}
          onClick={this.handleClick}
        />
        <FormText>{`${review.length}/100`}</FormText>
        {(!validate() && clicked)
          && (
          <p style={{ color: 'red' }}>
            <Translate id="review.reviewLength" />
          </p>
          )}
        {(!validate() && isSubmitted) && <p><Translate id="required" /></p>}
      </FormGroup>
    );
  }
}

Review.propTypes = {
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  chsite: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  review: PropTypes.string.isRequired,
  validate: PropTypes.func.isRequired,
};

export default withLocalize(Review);
